<template>
    <transition name="modal">
        <div v-if="product && visible" class="fixed top-0 left-0 w-full h-full z-[999]" style="background: rgba(0, 0, 0, .45);">
            <div class="wrapper_popup h-full" id="modal_add_to_cart">
                <div class="header_popup flex justify-between items-center h-12"
                    :class="{ 'error': errors.get('products_is_not_available') }">
                    <div class="pl-4">
                        <div>{{ $root.getLangText(product.title) }}</div>
                        <div class="text-red-500 pb-2 text-xs" v-if="errors.get('products_is_not_available')">{{ $root.getKeyWord('products_not_available') }}</div>
                    </div>
                    <button type="button" class="close_popup" @click="closeModal">
                        <svg width="48" height="48" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.2427 12.7574L12.7574 21.2426M12.7574 12.7574L21.2427 21.2426L12.7574 12.7574Z" stroke="#333333" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg>
                    </button>
                </div>

                <div class="content_popup px-4 pb-4">
                    <div class="my-5">
                        <div 
                            v-if="product.descr" 
                            v-html="$root.getLangText(product.descr) == '<br>' ? '' : $root.getLangText(product.descr)"
                            class="text-gray-600 section-description"
                        ></div>

                        <div class="flex items-center justify-between">
                            <div class="w-1/2">
                                <div class="spinner" v-if="product.show_quantity && product.is_popup">
                                    <v-input-quantity 
                                        :value.sync="quantity" 
                                        :min="1"
                                        :max="product.max_order_quantity == null ? 99 : parseInt(product.max_order_quantity)"
                                    ></v-input-quantity>
                                </div>
                            </div>
                            <div class="w-1/2 flex justify-end" v-if="parseFloat(price) > 0">
                                <div class="price_product" v-html="$root.showPrice(price, is_price_from)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-4">
                        <AppPropertiesNew 
                            ref="property_product" 
                            :property.sync="product.property"
                            :product-uuid="product.uuid" 
                            :max-booking-slot="product.max_booking_slot"
                            :quantity="quantity" 
                            :schedule="product.schedule" 
                            :errors="errors"
                        />
                    </div>

                    <div 
                        v-if="$root.hotel.is_payment_property && price > 0 && displayHotelPayments && cart.hotel_payments && cart.hotel_payments.length > 0"
                        class="wrapper_select mb-4 form_group"
                        :class="[errors && errors.get('payment') ? 'dirty valid' : '']"
                    >
                        <div class="flex pb-2">
                            <div class="header_option" :class="[errors && errors.get('payment') ? 'valid' : '']"
                                v-text="$root.getKeyWord('pay_method')"></div>
                            <span class="text-xs text-red-500 -mt-1 px-1"> *</span>
                        </div>
                        <select class="default_select appearance-none" v-model="cart.payment">
                            <option 
                                v-for="payment in cart.hotel_payments" 
                                :key="payment.id"
                                :value="payment.id" 
                            >
                                {{ $root.getLangText(payment.title) }}
                            </option>
                        </select>
                    </div>

                    <button 
                        v-if="$root.hotelCode === 'telegraph'"
                        class="flex items-center mb-2 justify-end w-full text-blue-500 space-x-1 transition"
                        @click="showFormDetails = !showFormDetails"
                    >
                        <span>{{ showFormDetails ? 'Hide guest details' : 'Show guest details' }}</span>
                        <svg class="w-4 h-4 transform transition-transform duration-300" :class="{ 'rotate-180': showFormDetails }" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
                    </button>

                    <div class="form_cart mt-4">
                        <transition name="accordion">
                            <div class="form_cart mt-2" v-show="showFormDetails">
                                <div 
                                    v-if="displayRoomNumber"
                                    class="mb-4 form_group"
                                    :class="[errors && errors.get('room_number') ? 'dirty valid' : '']"
                                >
                                    <div class="flex pb-2">
                                        <div class="header_option" v-text="roomNumberInputTitle()"></div>
                                        <span class="text-xs text-red-500 -mt-1 px-1"> *</span>
                                    </div>
                                    <div class="option">
                                        <input 
                                            type="text" 
                                            v-model="cart.room_number" 
                                            :disabled="disableEditRoomNumber"
                                            class="h-4" 
                                            title="property_room_number" 
                                        />
                                    </div>
                                    <span :class="errors && errors.get('room_number') ? 'opacity-100' : 'opacity-0'" class="text-xs text-red-500 -mt-1 px-1">{{ $root.getKeyWord('validation_room_number') }}</span>
                                </div>
                                <div>
                                    <AppPropertiesNew
                                        ref="property_hotel" 
                                        :property.sync="cart.property"
                                        :errors="errors"
                                    />
                                </div>

                                <div v-if="$root.hotel.is_comment_property" class="form_group mt-5">
                                    <div class="header_option pb-2" v-text="$root.getKeyWord('comments')"></div>
                                    <textarea id="message" v-model="cart.comment"></textarea>
                                </div>

                                <div v-if="$root.hotel.is_agreement_text && !$root.showConfirmationCheckBox()">
                                    <span class="text-xs text-gray-600 font-light" v-text="$root.getKeyWord('use_session')"></span>
                                    <span 
                                        class="text-xs underline text-gray-600 font-light ml-1 cursor-pointer"
                                        v-text="$root.getKeyWord('public_offer')"
                                        @click="$modal.show('modal-agreement'); $root.getPublicInformation('full_agreement')"
                                    ></span>
                                </div>

                                <div v-if="section.files && section.files.length > 0">
                                    <div class="text-xs flex justify-end items-center" v-for="file in section.files" :key="file">
                                        <a 
                                            :href="$root.getImage($root.getLangText(file.files))"
                                            v-if="$root.getImage($root.getLangText(file.files)).length > 0"
                                            class="border  px-4 py-2 my-2 text-blue font-light  text-black text-center rounded-full focus:outline-none flex items-center justify-center hover:bg-gray-300"
                                            target="_blank"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="20px" viewBox="0 0 24 24" width="20px" fill="#333" class="mr-3"><g><rect fill="none" height="24" width="24" /></g><g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z" /></g></svg>
                                            {{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <AppUkPrivacyPolicy 
                            v-if="$root.showConfirmationCheckBox()"
                            :check-agreement.sync="checked_agreement" 
                            :check-box-error.sync="check_box_error"
                            :is-public-offer="isPublicOffer" 
                            :is-privacy-policy="isPrivacyPolicy" 
                        />
                        <div class="flex my-2" v-if="$root.showPersonalDataCheckBox()">
                            <div @click="togglePersonalDataCheckbox" class="bg-white rounded border border-[#2c7a7b] w-4 h-4 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500 cursor-pointer">
                                <input type="checkbox" v-model="checked_privacy" class="opacity-0 absolute">
                                <svg :class="[checked_privacy ? 'block' : 'hidden']" class="w-3 h-3 pointer-events-none" fill="#2c7a7b" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z" /></svg>
                            </div>
                            <div 
                                v-if="this.$root.currentLanguage == 'ru'"
                                class="select-none text-xs leading-tight font-light"
                                :class="check_box_error ? 'text-red-500' : ''"
                            >
                                Ставя отметку, я даю ООО "Клип Стиль" согласие на обработку моих персональных данных для
                                осуществления заказов, бронирования услуг и коммуникации с сотрудниками отеля через
                                сервис 2ROOMZ по условиям, изложенным в
                                <a 
                                    class="text-[#2c7a7b]"
                                    @click="$modal.show('modal-personal-data'); $root.getPublicInformation('order_privacy')"
                                    href="javascript:void(0)"
                                >
                                    Согласии на обработку персональных данных </a>
                                    . Согласие можно отозвать в любой момент.
                            </div>
                            <div 
                                v-else 
                                class="select-none text-xs leading-tight font-light"
                                :class="check_box_error ? 'text-red-500' : ''"
                            >
                                By checking this box, I consent to Clip Style LLC processing my personal data for the
                                purpose of placing orders, booking services, and communicating with hotel staff through
                                the 2ROOMZ service, in accordance with the terms and conditions set forth in the
                                <a 
                                    class="text-[#2c7a7b]"
                                    @click="$modal.show('modal-personal-data'); $root.getPublicInformation('order_privacy')"
                                    href="javascript:void(0)"
                                >
                                    Personal Data Agreement </a>
                                . This consent can be revoked at any time.
                            </div>
                        </div>

                        <button 
                            v-if="!loading" 
                            class="default_green_btn mt-4" 
                            @click="createOrder"
                            v-text="buttonOrderText"
                        ></button>
                        <loading v-else :width="'w-14'" :height="'h-14'" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import AppPropertiesNew from '@/components/article/Properties/index';
import AppUkPrivacyPolicy from '@/components/article/AppUkPrivacyPolicy';
import Loading from '../../components/article/ArticleLoading.vue';
import { IsAnyProductGotRoomNumberOptionMixin } from '@/components/article/IsAnyProductGotRoomNumberOptionMixin';
import { eventBus } from '../../main';

class Errors {
    constructor() {
        this.errors = {};
    }

    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0];
        }
    }

    searchByKey(field) {
        return Object.keys(this.errors).filter(item => item.indexOf(field) > -1).length > 0;
    }

    record(errors) {
        this.errors = errors;
    }
}

export default {
    name: 'article-product-fast-cart',

    mixins: [IsAnyProductGotRoomNumberOptionMixin],

    components: { AppPropertiesNew, AppUkPrivacyPolicy, Loading },

    props: ['productId'],

    data() {
        return {
            showFormDetails: true,
            quantity: 1,
            checked_agreement: this.$root.showConfirmationCheckBox() ? false : true,
            checked_privacy: this.$root.showPersonalDataCheckBox() ? false : true,
            price: 0,
            status_payment: 'NONE',
            intervalCheckPayment: null,
            visible: false,
            product: null,
            section: null,
            parent_section: null,
            cart: null,
            loading: false,
            is_price_from: false,
            errors: new Errors(),
            check_box_error: false,
            isPrivacyPolicy: true,
        }
    },

    created() {
        console.log('ArticleProductFastStore created');
        eventBus.$on('calendar-dates-updated', () => {
            this.setTotalPrice();
        });

        this.$on('calendar-dates-updated', () => {
            this.setTotalPrice();
        });

        this.$root.$on('calendar-dates-updated', () => {
            this.setTotalPrice();
        });

        eventBus.$on('product-fast-cart', data => {
            this.$root.cleanCart();

            this.product = JSON.parse(data.product);
            this.section = data.section;
            this.parent_section = data.parent_section;
            this.price = parseFloat(data.product.price);
            this.visible = true;
            this.loading = false;
            this.errors = new Errors();

            this.is_price_from = this.product.is_price_from;
            let productIds = [this.product.id]
            var property = null;
            var params = {
                hotel_uuid: this.$root.hotel.uuid,
                filter: JSON.stringify({
                    product_ids: productIds
                })
            }
            let url = process.env.VUE_APP_API_URL + `public/properties`;
            this.$http.get(url, { params: params }).then(response => {
                this.cart.property = response.data.data
            });

            this.cart = localStorage['cart'] !== undefined
                ? JSON.parse(localStorage['cart'])
                : {
                    room_number: this.getDefaultRoomNumber(),
                    payment: null,
                    comment: '',
                    hotel_id: this.$root.hotel.id,
                    property: property,
                    uuid: '',
                    is_temporary: false,
                    products: []
                };

            this.cart.property = property;
            this.cart.payment = null;
            this.cart.comment = '';
            this.cart.hotel_payments = null;
            this.cart.is_temporary = false;

            url = process.env.VUE_APP_API_URL + `public/cart/payments`;
            params = {
                hotel_uuid: this.$root.hotel.uuid,
                product_ids: productIds
            };

            this.$http.get(url, { params: params }).then(response => {
                this.cart.hotel_payments = response.data.data
            });

            this.$nextTick(() => {
                eventBus.$emit('update-slot-calendar');
            });
        });
    },

    watch: {
        quantity(val) {
            if (val == undefined) return;

            this.setTotalPrice();
        },

        product: {
            handler: function (newValue) {
                this.setTotalPrice();
            },
            deep: true
        },

        'product.property': {
            handler: function (newValue) {
                this.setTotalPrice();
            },
            deep: true
        },

        visible(val) {
            this.$root.freezeActivePageScroll(val);
        },
    },

    computed: {
        disableEditRoomNumber() {
            return this.$root.hotelCode === 'telegraph' && !!this.room_number;
        },

        displayRoomNumber() {
            var products = [];
            products.push({
                parent_section: this.parent_section,
                section: this.section
            });

            return this.$root.hotel.is_room_number_property && this.$root.hotel.limit_room.length > 0 && this.isAnyProductGotRoomNumberOption(products);
        },


        buttonOrderText() {
            return this.buttonOrderTextAzimut;
        },

        buttonOrderTextAzimut() {
            let btnOrdTextProduct = this.$root.getLangText(this.product.button_order_text);
            let btnOrdTextSection = this.$root.getLangText(this.section?.button_order_text);
            let btnOrdTextParentSection = this.$root.getLangText(this.parent_section?.button_order_text);
            let btnOrdTextParentProduct = this.$root.getLangText(
                this.product?.parent?.button_order_text ||
                this.product?.parent_product?.button_order_text ||
                this.product?.product_parent?.button_order_text
            );

            if (btnOrdTextProduct)
                return btnOrdTextProduct
            if (btnOrdTextSection)
                return btnOrdTextSection
            if (btnOrdTextParentSection)
                return btnOrdTextParentSection
            if (btnOrdTextParentProduct)
                return btnOrdTextParentProduct

            return this.$root.getKeyWord('send_to_cart');
        },

        displayHotelPayments() {
            return true;
        },

        selectedPayment() {
            try {
                return this.$root.hotel?.payments?.find(item => item.id === this.cart.payment) || null;
            } catch (e) {
                console.error(e);
                return null;
            }
        },

        isPublicOffer() {
            const exceptions = [
                { id: '51249', hotel: 'ramadawyndhamessen' }
            ];

            if (!this.product) return true;

            return !exceptions.some(
                ex => this.product.id == ex.id && this.$root.hotelCode == ex.hotel
            );
        },
    },

    methods: {
        closeModal() {
            this.product = null;
            this.visible = false;
        },
        async createOrder() {
            // Validation checks first
            if (this.$root.showConfirmationCheckBox() && !this.checked_agreement) {
                this.check_box_error = true;
                return;
            }
            if (this.$root.showPersonalDataCheckBox() && !this.checked_privacy) {
                this.check_box_error = true;
                return;
            }

            // Check if this is a fast payment + online payment scenario
            // const is_fast = true; // Testing: set to true to test fast payment flow
            const is_fast = !!(this.$root.hotel && this.$root.hotel.ext_data && this.$root.hotel.ext_data.is_fast_payment);
            const is_online = this.selectedPayment && this.selectedPayment.ptype_id === 'online';
            
            console.log('[ArticleProductFastStore createOrder] is_fast_payment=', is_fast, 'is_online=', is_online, 'selectedPayment=', this.selectedPayment?.ptype_id);
            
            // Open new tab immediately on user click (before async operations)
            if (is_fast && is_online) {
                this._paymentWindow = window.open('about:blank', '_blank');
                console.log('[ArticleProductFastStore createOrder] window.open(about:blank) returned:', this._paymentWindow, 'type:', typeof this._paymentWindow, 'closed?', this._paymentWindow ? this._paymentWindow.closed : 'N/A');
                
                // Add loading content to the new window
                if (this._paymentWindow) {
                    if (this.$root.currentLanguage == 'ru') {
                        this._paymentWindow.document.write(`
                            <html>
                            <head>
                                <title>Processing Payment...</title>
                                <style>
                                body {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    height: 100vh;
                                    margin: 0;
                                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                                    background: #f5f5f5;
                                }
                                .loader {
                                    text-align: center;
                                }
                                .spinner {
                                    border: 4px solid #f3f3f3;
                                    border-top: 4px solid #3498db;
                                    border-radius: 50%;
                                    width: 50px;
                                    height: 50px;
                                    animation: spin 1s linear infinite;
                                    margin: 0 auto 20px;
                                }
                                @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                                h2 {
                                    color: #333;
                                    margin: 0 0 10px;
                                }
                                p {
                                    color: #666;
                                    margin: 0;
                                }
                                </style>
                            </head>
                            <body>
                                <div class="loader">
                                <div class="spinner"></div>
                                <h2>Обработка платежа...</h2>
                                <p>Пожалуйста, подождите, не закрывайте это окно.</p>
                                </div>
                            </body>
                            </html>
                        `);
                    } else {
                        this._paymentWindow.document.write(`
                            <html>
                            <head>
                                <title>Processing Payment...</title>
                                <style>
                                body {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    height: 100vh;
                                    margin: 0;
                                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                                    background: #f5f5f5;
                                }
                                .loader {
                                    text-align: center;
                                }
                                .spinner {
                                    border: 4px solid #f3f3f3;
                                    border-top: 4px solid #3498db;
                                    border-radius: 50%;
                                    width: 50px;
                                    height: 50px;
                                    animation: spin 1s linear infinite;
                                    margin: 0 auto 20px;
                                }
                                @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                                h2 {
                                    color: #333;
                                    margin: 0 0 10px;
                                }
                                p {
                                    color: #666;
                                    margin: 0;
                                }
                                </style>
                            </head>
                            <body>
                                <div class="loader">
                                <div class="spinner"></div>
                                <h2>Processing your payment...</h2>
                                <p>Please wait, do not close this window.</p>
                                </div>
                            </body>
                            </html>
                        `);
                    }
                }
            } else {
                this._paymentWindow = null;
            }

            // Handle reCAPTCHA
            try {
                console.log('this.$root.hotel.is_active_recaptcha', this.$root.hotel.is_active_recaptcha);
                
                if (this.$root.hotel.is_active_recaptcha) {
                    const token = await this.$recaptcha('order_submit');
                    this.cart.recaptcha_token = token;
                } else {
                    this.cart.recaptcha_token = null;
                }
                
                this.sendOrder();
            } catch (err) {
                console.error('reCAPTCHA failed', err);
                
                // Close payment window if reCAPTCHA fails
                if (this._paymentWindow && !this._paymentWindow.closed) {
                this._paymentWindow.close();
                }
                this._paymentWindow = null;
                
                if (this.$root.hotel.is_active_recaptcha) {
                    alert('reCAPTCHA verification failed. Please try again.');
                } else {
                    this.sendOrder();
                }
            }
        },

        sendOrder() {
            if (this.loading)
                return false;

            this.loading = true;

            this.cart.uuid = this.$root.generate_and_set_uuid();

            let calendarProperty = null;
            let hasSeparateDays = false;
            let calendarDates = [];

            if (this.product.property_kit_id > 0 && this.product.property.id !== undefined) {
                calendarProperty = this.product.property.properties.find(item =>
                    item.ptype_id === 'calendar' &&
                    item.value &&
                    Array.isArray(item.value) &&
                    item.value.length > 0
                );

                if (calendarProperty) {
                    hasSeparateDays = calendarProperty.extra && calendarProperty.extra.separate_days === true;
                    calendarDates = calendarProperty.value;
                }
            }

            if (hasSeparateDays && calendarDates.length > 0) {
                this.cart.products = calendarDates.map(date => {
                    let productCopy = JSON.parse(JSON.stringify(this.product));

                    if (productCopy.property && productCopy.property.properties) {
                        let calendarProp = productCopy.property.properties.find(p => p.ptype_id === 'calendar');
                        if (calendarProp) {
                            calendarProp.value = [date];
                        }
                    }

                    return {
                        product: productCopy,
                        quantity: this.quantity,
                        total_price: this.price / calendarDates.length,
                        from_recommendation: this.from_recommendation,
                        section: this.section,
                        parent_section: this.parent_section,
                    };
                });
            } else {
                this.cart.products = [
                    {
                        product: this.product,
                        quantity: this.quantity,
                        total_price: this.price,
                        from_recommendation: this.from_recommendation,
                        section: this.section,
                        parent_section: this.parent_section,
                    }
                ];
            }

            this.cart.hotel_id = this.$root.hotel.id;

            let sendCart = this.$root.buildCart(this.cart);
            sendCart.language = this.$root.currentLanguage;
            sendCart.recaptcha_token = this.cart.recaptcha_token;

            this.$http.post(process.env.VUE_APP_API_URL + 'orders', sendCart).then(({ data }) => {
                if (data.data.order !== undefined && data.data.order.uuid) {
                    this.$root.store_order_uuid(data.data.order.uuid);
                }

                var payment_url = null;
                // var is_fast_payment = true; // Testing: set to true to test fast payment flow
                var is_fast_payment = !!(this.$root.hotel && this.$root.hotel.ext_data && this.$root.hotel.ext_data.is_fast_payment);
                
                if (this.selectedPayment && this.selectedPayment.ptype_id === 'online') {
                    if (data.data.pay_data?.response?.formUrl) {
                        payment_url = data.data.pay_data.response.formUrl;
                        
                        // Fast payment: redirect in the new tab
                        if (is_fast_payment && payment_url) {
                            console.log('[ArticleProductFastStore then] fast_payment + payment_url. _paymentWindow=', this._paymentWindow, 'closed?', this._paymentWindow ? this._paymentWindow.closed : 'N/A');
                            this.visible = false;
                            this.$root.cleanCart();
                            this.loading = false;
                            
                            if (this._paymentWindow && !this._paymentWindow.closed) {
                                console.log('[ArticleProductFastStore then] using NEW TAB (_paymentWindow.location.href)');
                                this._paymentWindow.location.href = payment_url;
                                this._paymentWindow.focus();
                            } else {
                                console.log('[ArticleProductFastStore then] fallback CURRENT TAB (window.location.href)');
                                window.location.href = payment_url;
                            }
                            this._paymentWindow = null;
                            
                            eventBus.$emit('order-success-splash', {
                                section: this.cart.products[0].section,
                                parent_section: this.cart.products[0].parent_section,
                                total_price: this.product.price,
                                payment_url: payment_url,
                            });
                            eventBus.$emit('order-created');
                            return data;
                        }
                        
                        // Non-fast payment: show popup with payment URL
                        if (this._paymentWindow && !this._paymentWindow.closed) this._paymentWindow.close();
                        this.successOrderPopup(payment_url);
                        return data;
                    }
                    
                    // If is_fast_payment but no payment_url, show error in the payment window instead of closing
                    if (is_fast_payment && this._paymentWindow && !this._paymentWindow.closed) {
                        console.log('[ArticleProductFastStore then] fast_payment but NO payment_url - showing error in payment window');
                        this._paymentWindow.document.body.innerHTML = `
                            <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;background:#f5f5f5;">
                                <div style="text-align:center;padding:20px;">
                                    <h2 style="color:#e53e3e;">Payment URL not received</h2>
                                    <p style="color:#666;">The server did not return a payment URL.</p>
                                    <p style="color:#666;">Please close this tab and try again.</p>
                                    <p style="color:#999;font-size:12px;margin-top:20px;">Debug: pay_data=${JSON.stringify(data.data.pay_data)}</p>
                                </div>
                            </div>
                        `;
                        this.successOrderPopup(payment_url);
                        return data;
                    }
                }

                // Close payment window if open (non-online payment or no fast payment)
                if (this._paymentWindow && !this._paymentWindow.closed) this._paymentWindow.close();
                this._paymentWindow = null;
                
                this.successOrderPopup();
                this.loading = false;

                return data;
            }).catch(error => {
                this.loading = false;
                // Close payment window on error
                if (this._paymentWindow && !this._paymentWindow.closed) this._paymentWindow.close();
                this._paymentWindow = null;
                
                if (this.showFormDetails === false) {
                    this.showFormDetails = true;
                }
                console.error(error);
                this.errors.record(error.response?.data?.data || {});
            });
        },

        successOrderPopup(payment_url = null) {
            // hide cart, display success popup
            this.visible = false;
            var firstSection = this.cart.products[0].section;
            eventBus.$emit('order-success-splash', {
                section: this.cart.products[0].section,
                parent_section: this.cart.products[0].parent_section,
                total_price: this.product.price,
                payment_url: payment_url,
            });

            eventBus.$emit('order-created');

            this.$root.cleanCart();
        },

        getDefaultRoomNumber() {
            if (this.$root.hotelCode == 'palmira-bc') return '';

            return (localStorage.getItem('fs_room_number') != undefined) ? localStorage.getItem('fs_room_number') : '';
        },

        togglePersonalDataCheckbox() {
            this.checked_privacy = !this.checked_privacy;
        },

        setTotalPrice() {
            if (this.product === undefined || this.product === null)
                return;

            let total = 0;
            let product_price = parseFloat(this.product.price);
            let property_total_price = 0;
            let calendar_days = 1;
            let has_separate_days = false;

            this.is_price_from = this.product.is_price_from;

            if (this.product.property_kit_id > 0 && this.product.property.id !== undefined) {
                this.product.property.properties.filter(item => item.value !== '' && item.value !== null && item.ptype_id == 'calendar').map(item => {
                    if (item.value && Array.isArray(item.value) && item.value.length > 0) {
                        calendar_days = item.value.length;
                        has_separate_days = item.extra && item.extra.separate_days === true;
                    }
                });

                this.product.property.properties.filter(item => item.value !== '' && item.value !== null && item.price_type_id !== 'none').map(item => {

                    if (item.ptype_id == 'calendar') {
                        return;
                    }

                    if (item.price_type_id === 'replace')
                        product_price = 0;

                    if (item.price_type_id === 'plus' || item.price_type_id === 'replace') {
                        if (item.ptype_id == 'select') {
                            property_total_price += item.attrs.filter(item_attr => parseInt(item.value) === item_attr.id && item_attr.price !== null).reduce(function (acc, item_attr) {
                                return acc + parseFloat(item_attr.price) * item_attr.quantity;
                            }, 0);
                        } else if (item.ptype_id == 'checkbox') {
                            var attr_price = item.attrs.filter(item_attr => item_attr.checked && item_attr.price !== null).reduce(function (acc, item_attr) {
                                return acc + parseFloat(item_attr.price) * item_attr.quantity;
                            }, 0);

                            attr_price = attr_price === 0 && item.price > 0 ? item.price : attr_price;

                            property_total_price += attr_price;
                        } else if (item.price > 0) {
                            property_total_price += item.price;
                        }
                    }
                });
            }

            let price_multiplier = has_separate_days ? calendar_days : 1;
            this.price = this.quantity * (product_price + parseFloat(property_total_price)) * price_multiplier;

            if (this.price !== product_price)
                this.is_price_from = false;
        }
    }
}
</script>

<style>
.multiselect__tags {
    min-height: 34px;
    display: block;
    padding: 8px 40px 0 8px;
    border: 1px solid #F2F2F2;
    background: #fff;
    font-size: 14px;
    height: 34px;
    border-radius: 8px;
}

.multiselect__select:before {
    display: none;
}

.multiselect__input,
.multiselect__single {
    line-height: 14px;
}

.grecaptcha-badge {
    right: -1000px !important;
}
</style>
